import '../static/Dropdown.css';
import * as React from "react";
import React__default, { forwardRef, useReducer, useId, useRef, useState, useImperativeHandle, useCallback } from "react";
import clsx from "clsx";
import { a as InputControlled } from "./Input.CXxqKRC9.mjs";
import { F as FlyingMenu } from "./FlyingMenu.DB9naeeI.mjs";
import { S as SvgSpinnerAnimated1Px } from "./spinner-animated-1px.DkxgkEsL.mjs";
const SvgChevronDown1Px = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentcolor", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M2.146 6.646a.5.5 0 0 1 .708 0L10 13.793l7.146-7.147a.5.5 0 0 1 .708.708l-7.5 7.5a.5.5 0 0 1-.708 0l-7.5-7.5a.5.5 0 0 1 0-.708", clipRule: "evenodd" }));
const dropdown = `_dropdown_e93816b`;
const loading = `_loading_90edd37`;
const caret = `_caret_0d42654`;
const caretOpen = `_caretOpen_24613be`;
const menu = `_menu_f70244a`;
const styles = { dropdown, loading, caret, caretOpen, menu };
const UNSELECTED_OPTION = {
  value: "",
  label: "",
  index: -1
};
function createInitialState(options, defaultValue) {
  const selectedOption = findOptionByValue(options, defaultValue);
  return {
    inputValue: selectedOption.label,
    selectedOption,
    filteredOptions: options
  };
}
function findOptionByValue(options, value) {
  const index = options.findIndex((option) => option.value === value);
  if (index > -1) {
    return {
      ...options[index],
      index
    };
  }
  return UNSELECTED_OPTION;
}
function searchOptionsByLabel(options, inputValue) {
  return options.filter(
    (option) => option.label.toLocaleLowerCase().includes(inputValue.trim().toLocaleLowerCase())
  );
}
function dropdownReducer(state, action) {
  switch (action.type) {
    case "updateOption": {
      const option = {
        ...state.filteredOptions[action.index],
        index: action.index
      };
      return {
        ...state,
        inputValue: option.label,
        selectedOption: option
      };
    }
    case "searchOptions": {
      return {
        ...state,
        inputValue: action.value,
        filteredOptions: searchOptionsByLabel(action.options, action.value)
      };
    }
    case "reset": {
      if (action.defaultValue) {
        return createInitialState(action.options, action.defaultValue);
      }
      return {
        inputValue: "",
        selectedOption: UNSELECTED_OPTION,
        filteredOptions: action.options
      };
    }
  }
}
const DropdownInner = ({
  id = "dropdown",
  className,
  name,
  onBlur,
  onChange = () => {
  },
  onClick,
  options,
  disabled,
  defaultValue = "",
  loading: loading2,
  noResultsLabel = "No results found",
  theme,
  ...props
}, ref) => {
  const [{ inputValue, selectedOption, filteredOptions }, dispatch] = useReducer(dropdownReducer, createInitialState(options, defaultValue));
  const popoverId = useId();
  const labelId = `${popoverId}-label`;
  const innerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useImperativeHandle(ref, () => innerRef.current, []);
  const togglePopover = useCallback((open) => {
    var _a;
    if (open) {
      (_a = innerRef == null ? void 0 : innerRef.current) == null ? void 0 : _a.focus();
    }
    setIsOpen(open);
  }, []);
  const handleOptionClick = (index) => {
    dispatch({ type: "updateOption", index });
    onChange(filteredOptions[index].value);
  };
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: clsx(
        styles.dropdown,
        {
          [styles.loading]: loading2
        },
        className
      )
    },
    /* @__PURE__ */ React__default.createElement("input", { type: "hidden", name, value: selectedOption.value }),
    /* @__PURE__ */ React__default.createElement(
      InputControlled,
      {
        ...props,
        id,
        labelId,
        type: "text",
        role: "combobox",
        "aria-autocomplete": "list",
        ref: innerRef,
        autoComplete: "off",
        autoCapitalize: "none",
        autoCorrect: "off",
        spellCheck: "false",
        disabled,
        value: inputValue,
        theme,
        onChange: (value) => {
          togglePopover(true);
          dispatch({ type: "searchOptions", value, options });
        },
        onClick: (e) => {
          togglePopover(true);
          if (onClick)
            onClick(e);
        },
        onBlur: (e) => {
          const optionsList = searchOptionsByLabel(filteredOptions, inputValue);
          const singleOption = optionsList.length === 1 ? optionsList[0] : null;
          if (singleOption) {
            handleOptionClick(
              findOptionByValue(filteredOptions, singleOption.value).index
            );
          } else {
            dispatch({ type: "reset", options, defaultValue });
          }
          togglePopover(false);
          if (onBlur)
            onBlur(e);
        },
        suffix: loading2 ? /* @__PURE__ */ React__default.createElement(SvgSpinnerAnimated1Px, { className: styles.caret }) : /* @__PURE__ */ React__default.createElement(
          SvgChevronDown1Px,
          {
            className: clsx(styles.caret, { [styles.caretOpen]: !!isOpen })
          }
        )
      }
    ),
    /* @__PURE__ */ React__default.createElement(
      FlyingMenu,
      {
        id: popoverId,
        anchorRef: innerRef,
        open: isOpen,
        onChange: handleOptionClick,
        onClose: () => togglePopover(false),
        defaultSelected: selectedOption.index,
        role: "listbox",
        itemRole: "option",
        className: styles.menu
      },
      filteredOptions.length ? filteredOptions == null ? void 0 : filteredOptions.map((option) => /* @__PURE__ */ React__default.createElement("span", { key: option.value, "data-value": option.value }, option.label)) : /* @__PURE__ */ React__default.createElement("span", { "aria-hidden": "true" }, noResultsLabel)
    )
  );
};
const Dropdown = forwardRef(
  DropdownInner
);
export {
  Dropdown as D
};
//# sourceMappingURL=Dropdown.BqiZo-7k.mjs.map
